const lightPalette = {
  mode: "light",
  common: {
    black: "#1A1C19",
    white: "#FFFFFF",
    dataCell: "#4a4a4a"
  },
  primary: {
    darker: "#450410",
    dark: "#670517",
    main: "#89071F",
    light: "#C4838F",
    lighter: "#E1C1C7",
    lightest1: "#F3E6E8",
    lightest2: "#F9F2F4",
  },
  secondary: {
    darker: "#1B202D",
    dark: "#283043",
    main: "#34405C",
    light: "#9A9FAC",
    lighter: "#CDCFD6",
    lightest1: "#EBECEE",
    lightest2: "#F5F5F7",
  },
  default: {
    darker: "#191919",
    dark: "#252525",
    main: "#0A0A0A",
    light: "#737373",
    lighter: "#CCCCCC",
    lightest1: "#EAEAEA",
    lightest2: "#F5F5F5",
  },
  success: {
    dark: "#19571C",
    main: "#2E7D32",
    light: "#96BE98",
    lighter: "#CBDECC",
  },
  error: {
    darker: "#5D0D0D",
    dark: "#8B1313",
    main: "#BA1A1A",
    light: "#DC8C8C",
    lighter: "#EEC6C6",
    lightest1: "#F8E8E8",
    lightest2: "#FBF3F3",
  },
  wraning: {
    dark: "#C85A00",
    main: "#ED6C02",
    light: "#FFAF6D",
    lighter: "#FADAC0",
  },
  background: {
    default: "#FFFFFF",
    paper: "#FFFFFF",
  },
};

const darkPalette = {
  mode: "dark",
  common: {
    black: "#10111E",
    white: "#fff",
    green: "#58B84A",
    page: "#18191F",
    headerbg: "#2C3345",
    errorbg: "#FDE0E0",
    errortext: "#683333",
    warningbg: "#FCEDD8",
    inputs: "#E6EAF5",
    red: "#FF6C6C",
  },
  primary: {
    main: "#F29B2A",
    dark: "#C87F1A",
    darker: "#070812",
    lightdark: "#10111E",
  },
  secondary: {
    main: "#6B8EAC",
    text: "#ABC6D1",
    light: "#ECF7FF",
    lightest: "#2C3345",
  },
  background: {
    default: "#0000",
    paper: "#1e1f2a",
    cardGradient: "linear-gradient(145deg, #141625, #272939)",
    inputGradient: "linear-gradient(to bottom,#C1C8DB, #7e828a)",
    inputGradientIcon: "#abb0bf",
    treeGradient: "linear-gradient(to bottom,#272939, #151727)",
  },
};

export { darkPalette, lightPalette };
